<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
          <div class="progress-bar-bg">
            <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
          </div>
        </div>

        <div class="step-nav-buttons mt-4">
              <button
                type="button"
                class="btn previous-step"
                @click="prevStep"
                v-if="currentStep != 1"
              >
                Back
              </button>
        </div>

        <div class="calculator-container">

          <div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">
            <BooleanChoiceButtons
                fieldText="Are you purchasing or remortgaging a Buy To Let"
                buttonTextLeft="Purchasing"
                buttonTextRight="Remortgaging"
                v-if="currentStep === 1"
            >
              <template v-slot:left>
                <input type="radio" v-model="startOption" value="Purchasing" @click="clearRemortgagingResults">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="startOption" value="Remortgaging" @click="clearPurchasingResults">
              </template>
            </BooleanChoiceButtons>

            <div class="row mb-5" v-if="currentStep === 2">
              <h4 class="calc-fieldset-title">Type of Buy to Let</h4>
              <div class="col-12 row calc-right-buttons-wrapper">
                <MultiplyChoiceButton
                    buttonText="Individual"
                >
                  <input type="radio" v-model="typeBTL" value="Individual" @click="clearHmoLtdResults">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="HMO"
                >
                  <input type="radio" v-model="typeBTL" value="HMO" @click="clearIndividualLtdResults">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="LTD Company"
                >
                  <input type="radio" v-model="typeBTL" value="LTD Company" @click="clearIndividualHmoResults">
                </MultiplyChoiceButton>
              </div>
            </div>

            <div v-if="currentStep === 3">
              <h4 class="calc-fieldset-title">Individual</h4>
              <BooleanChoiceButtons
                fieldText="Is your tax rate 40% or higher?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="individualTaxRate" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="individualTaxRate" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>

            <div v-if="currentStep === 4">
              <h4 class="calc-fieldset-title">Individual</h4>
              <BooleanChoiceButtons
                fieldText="If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="individualFixedMortgage" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="individualFixedMortgage" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>
            
            <div v-if="currentStep === 5">
              <h4 class="calc-fieldset-title">Individual</h4>
              <InputElement
                  
                  fieldText="How much rent do you get or expect to get?"
              >
                <InputTypeNumber currencyPlaceholder v-model="individualExpectedRent" @keyup="resetCalculation"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 6">
              <h4 class="calc-fieldset-title">HMO</h4>
              <BooleanChoiceButtons
                fieldText="Will or is the property held in a limited company?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="hmoPropertyHeldIn" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="hmoPropertyHeldIn" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>

            <div v-if="currentStep === 7">
              <h4 class="calc-fieldset-title">HMO</h4>
              <BooleanChoiceButtons
                fieldText="Does the property have an HMO Licence?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="hmoLicence" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="hmoLicence" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>
            
            <div v-if="currentStep === 8">
              <h4 class="calc-fieldset-title">HMO</h4>
              <BooleanChoiceButtons
                fieldText="If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="hmoFixedMortgage" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="hmoFixedMortgage" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>
              
            <div v-if="currentStep === 9">
              <h4 class="calc-fieldset-title">HMO</h4>
              <InputElement
                  
                  fieldText="How much rent do you get or expect to get?"
              >
                <InputTypeNumber currencyPlaceholder v-model="hmoExpectedRent" @keyup="resetCalculation"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 10">
              <h4 class="calc-fieldset-title">LTD Company</h4>
              <BooleanChoiceButtons
                fieldText="Do you have an SPV in place?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="ltdSpvInPlace" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="ltdSpvInPlace" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>

            <div v-if="currentStep === 11">
              <h4 class="calc-fieldset-title">LTD Company</h4>
              <InputElement
                  
                  fieldText="How many Directors are in the company?"
              >
                <InputTypeNumber v-model="ltdDirectorlQuantity"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 12">
              <h4 class="calc-fieldset-title">LTD Company</h4>
              <InputElement
                  
                  fieldText="How much personal income do you earn per year?"
              >
                <InputTypeNumber currencyPlaceholder v-model="ltdDirectorlIncome"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 13">
              <h4 class="calc-fieldset-title">LTD Company</h4>
              <BooleanChoiceButtons
               
                fieldText="If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
              >
                <template v-slot:left>
                  <input type="radio" v-model="ltdFixedMortgage" value="Yes">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="ltdFixedMortgage" value="No">
                </template>
              </BooleanChoiceButtons>
            </div>

            <div v-if="currentStep === 14">
              <h4 class="calc-fieldset-title">LTD Company</h4>
              <InputElement
                  
                  fieldText="How much rent do you get or expect to get?"
              >
                <InputTypeNumber currencyPlaceholder v-model="ltdExpectedRent" @keyup="resetCalculation"/>
              </InputElement>
            </div>
            

            <BooleanChoiceButtons
                fieldText="Do you have a property in mind?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
                v-if="currentStep === 15"
            >
              <template v-slot:left>
                <input type="radio" v-model="propertyInMind" value="Yes" @click="clearApproxPurchaseValue">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="propertyInMind" value="No" @click="clearPurchaseValue">
              </template>
            </BooleanChoiceButtons>

            <div v-if="currentStep === 16">
              <InputElement
                  
                  fieldText="What is the purchase price?"
              >
                <InputTypeNumber currencyPlaceholder v-model="purchaseValue"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 17">
              <InputElement
                  
                  fieldText="Approximately, what value would you like to purchase at?"
              >
                <InputTypeNumber currencyPlaceholder v-model="approxPurchaseValue"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 18">
              <InputElement
                  
                  fieldText="How many lettable rooms does the property have?"
              >
                <InputTypeNumber v-model="hmoLettableRooms"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 19">
              <InputElement
                  
                  fieldText="What is your required mortgage amount?"
              >
                <InputTypeNumber currencyPlaceholder v-model="requiredMortgageAmount"/>
              </InputElement>
            </div>

            <BooleanChoiceButtons
                fieldText="Are you a first time landlord?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
                v-if="currentStep === 20"
            >
              <template v-slot:left>
                <input type="radio" v-model="firstTimeLandlord" value="Yes" @click="clearPropertiesQuantity">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="firstTimeLandlord" value="No">
              </template>
            </BooleanChoiceButtons>

            <div v-if="currentStep === 21">
              <InputElement
                  
                  fieldText="How many rental properties do you own?"
              >
                <InputTypeNumber v-model="propertiesQuantity"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 22">
              <InputElement
                  
                  fieldText="What is the approximate value of your property?"
              >
                <InputTypeNumber currencyPlaceholder v-model="approxPropValue"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 23">
              <InputElement
                  
                  fieldText="What is your current outstanding mortgage amount?"
              >
                <InputTypeNumber currencyPlaceholder v-model="outstandingMortgage"/>
              </InputElement>
            </div>

            <div v-if="currentStep === 24">
              <InputElement
                  
                  fieldText="Who is your current lender?"
              >
                <input id="currentLender" class="form-control calc-form-control" type="text" v-model="currentLender">
              </InputElement>
            </div>

            <BooleanChoiceButtons
                fieldText="Are you remortgaging with additional borrowing?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
                v-if="currentStep === 25"
            >
              <template v-slot:left>
                <input type="radio" v-model="additionalBorrowing" value="Yes">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="additionalBorrowing" value="No">
              </template>
            </BooleanChoiceButtons>

            <div v-if="currentStep === 26">
              <InputElement
                  
                  fieldText="How much more would you like to borrow?"
              >
                <InputTypeNumber currencyPlaceholder v-model="borrowAmount"/>
              </InputElement>
            </div>

            <BooleanChoiceButtons
                fieldText="Do you have any more rental properties?"
                buttonTextLeft="Yes"
                buttonTextRight="No"
                v-if="currentStep === 27"
            >
              <template v-slot:left>
                <input type="radio" v-model="additionalRentalProps" value="Yes">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="additionalRentalProps" value="No"
                        @click="clearAdditionalRentalPropsAmount">
              </template>
            </BooleanChoiceButtons>

            <div v-if="currentStep === 28">
              <InputElement
                  
                  fieldText="Do you have any more rental properties?"
              >
                <InputTypeNumber v-model="additionalRentalPropsAmount"/>
              </InputElement>
            </div>
            
            <div class="row mb-5" v-if="currentStep === 29">
              <div class="col-12 booleanLabel">Why are you using the calculator today?</div>
              <div class="col-12 row calc-right-buttons-wrapper">
                <MultiplyChoiceButton
                    buttonText="I’m ready to get a mortgage"
                >
                  <input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I’m curious to know what I can borrow"
                >
                  <input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
                </MultiplyChoiceButton>
                <MultiplyChoiceButton
                    buttonText="I want to understand what I can afford before I search for a home"
                >
                  <input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
                </MultiplyChoiceButton>
                </div>
            </div>

            <div class="row mb-5" v-if="currentStep === 30">
                <div class="col-12 booleanLabel">When are you hoping to move?</div>
                <div class="col-12 row calc-right-buttons-wrapper">
                  <MultiplyChoiceButton
                      buttonText="As soon as possible"
                  >
                    <input type="radio" v-model="calcReason2" value="As soon as possible">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="In the next 3 months"
                  >
                    <input type="radio" v-model="calcReason2" value="In the next 3 months">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="6-12 months from now"
                  >
                    <input type="radio" v-model="calcReason2" value="6-12 months from now">
                  </MultiplyChoiceButton>
                  <MultiplyChoiceButton
                      buttonText="12+ months from now"
                  >
                    <input type="radio" v-model="calcReason2" value="12+ months from now">
                  </MultiplyChoiceButton>
                  </div>
              </div>
            
              <div class="step-nav-buttons mt-4 text-center">
                <button
                  type="button"
                  class="btn next-step"
                  @click="nextStep"
                  v-if="currentStep != totalSteps - 1 && currentStep != 31"
                  :disabled="!isStepValid"
                >
                  Continue
                </button>

                <button
                  type="button"
                  class="btn calculate"
                  v-if="currentStep === totalSteps - 1"
                  @click="calculate"
                  :disabled="!isStepValid"
                >
                  Calculate
                </button>
              </div>
            
          </div>

          <div v-if="currentStep === 31" ref="resultsContainer">

            <ResultsContainer class="mt-5 mb-5 calc-results-box">
              <div class="mb-3 results-title">You may be able to borrow:</div>
              <span class="fcs-price">£{{ this.result }}</span>
              <div class="mt-3">The figure quoted gives you an indication based upon the likely rent being achieved,
                the actual borrowing may be limited to 80% of the price or value of property.
              </div>
            </ResultsContainer>

            <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 31,
      calculatorName: 'buy-to-let-calculator',

      startOption: '',
      typeBTL: '',

      //Individual
      individualTaxRate: '',
      individualFixedMortgage: 0,
      individualExpectedRent: 0,

      //HMO
      hmoPropertyHeldIn: '',
      hmoLicence: '',
      hmoLettableRooms: 0,
      hmoFixedMortgage: 0,
      hmoExpectedRent: 0,

      //LTD
      ltdSpvInPlace: '',
      ltdDirectorlQuantity: 0,
      ltdDirectorlIncome: 0,
      ltdFixedMortgage: '',
      ltdExpectedRent: 0,

      //Purchasing
      propertyInMind: '',
      purchaseValue: 0,
      approxPurchaseValue: 0,
      requiredMortgageAmount: 0,
      firstTimeLandlord: '',
      propertiesQuantity: 0,

      //Remortgaging
      approxPropValue: 0,
      outstandingMortgage: 0,
      currentLender: '',
      additionalBorrowing: '',
      borrowAmount: 0,
      additionalRentalProps: '',
      additionalRentalPropsAmount: 0,

      result: '',
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
      switch (this.typeBTL) {
        case "Individual":
          this.individualTaxRate === 'Yes'
              ? this.result = this.indiv40Calc.toFixed(2)
              : this.result = this.indiv20Calc.toFixed(2)
          break;
        case "HMO":
          if( this.hmoExpectedRent > 0 ) { this.result = this.hmoCalc.toFixed(2) }
          break;
        case "LTD Company":
          if( this.ltdExpectedRent > 0 ) { this.result = this.ltdCalc.toFixed(2) }
          break;
        default:
          this.result = ''
          break;
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    clearPurchasingResults() {
      this.propertyInMind = '',
          this.purchaseValue = 0,
          this.approxPurchaseValue = 0,
          this.requiredMortgageAmount = 0,
          this.firstTimeLandlord = '',
          this.propertiesQuantity = 0
    },
    clearRemortgagingResults() {
      this.approxPropValue = 0,
          this.outstandingMortgage = 0,
          this.currentLender = '',
          this.additionalBorrowing = '',
          this.borrowAmount = 0,
          this.additionalRentalProps = '',
          this.additionalRentalPropsAmount = 0
    },
    clearHmoLtdResults() {
      this.hmoPropertyHeldIn = '',
          this.hmoLicence = '',
          this.hmoLettableRooms = 0,
          this.hmoFixedMortgage = 0,
          this.hmoExpectedRent = 0
      this.ltdSpvInPlace = '',
          this.ltdDirectorlQuantity = 0,
          this.ltdDirectorlIncome = 0,
          this.ltdFixedMortgage = '',
          this.ltdExpectedRent = 0
    },
    clearIndividualLtdResults() {
      this.individualTaxRate = '',
          this.individualFixedMortgage = 0,
          this.individualExpectedRent = 0,
          this.ltdSpvInPlace = '',
          this.ltdDirectorlQuantity = 0,
          this.ltdDirectorlIncome = 0,
          this.ltdFixedMortgage = '',
          this.ltdExpectedRent = 0
    },
    clearIndividualHmoResults() {
      this.individualTaxRate = '',
          this.individualFixedMortgage = 0,
          this.individualExpectedRent = 0,
          this.hmoPropertyHeldIn = '',
          this.hmoLicence = '',
          this.hmoLettableRooms = 0,
          this.hmoFixedMortgage = 0,
          this.hmoExpectedRent = 0
    },
    clearApproxPurchaseValue() {
      this.approxPurchaseValue = 0
    },
    clearPurchaseValue() {
      this.purchaseValue = 0
    },
    clearPropertiesQuantity() {
      this.propertiesQuantity = 0
    },
    clearAdditionalRentalPropsAmount() {
      this.additionalRentalPropsAmount = 0
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
      if (this.currentStep === 2 && this.typeBTL === 'Individual') {
        this.currentStep = 3;
      } else if (this.currentStep === 2 && this.typeBTL === 'HMO') {
        this.currentStep = 6;
      } else if (this.currentStep === 2 && this.typeBTL === 'LTD Company') {
        this.currentStep = 10;
      } else if (this.currentStep === 5 && this.typeBTL === 'Individual') {
        this.currentStep = 15;
      } else if (this.currentStep === 16 && this.typeBTL === 'Individual') {
        this.currentStep = 19;
      } else if (this.currentStep === 20 && this.firstTimeLandlord === 'Yes') {
        this.currentStep = 29;
      } else if (this.currentStep === 20 && this.firstTimeLandlord === 'No') {
        this.currentStep = 21;
      } else if (this.currentStep === 21 && this.firstTimeLandlord === 'No') {
        this.currentStep = 29;
      } else if (this.currentStep === 15 && this.typeBTL === 'Individual' && this.propertyInMind === 'No') {
        this.currentStep = 17;
      } else if (this.currentStep === 17 && this.typeBTL === 'Individual' && this.propertyInMind === 'No') {
        this.currentStep = 19;
      } else if (this.currentStep === 2 && this.typeBTL === 'HMO' ) {
        this.currentStep = 6;
      } else if (this.currentStep === 9 && this.typeBTL === 'HMO' && this.startOption === 'Purchasing') {
        this.currentStep = 15;
      } else if (this.currentStep === 15 && this.typeBTL === 'HMO'  && this.propertyInMind === 'No') {
        this.currentStep = 17;
      } else if (this.currentStep === 16 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'Yes') {
        this.currentStep = 19;
      } else if (this.currentStep === 15 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'No') {
        this.currentStep = 17;
      } else if (this.currentStep === 17 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'No') {
        this.currentStep = 19;
      } else if (this.currentStep === 16 && this.typeBTL === 'HMO') {
        this.currentStep = 18;
      } else if (this.currentStep === 5 && this.typeBTL === 'Individual' && this.startOption === 'Remortgaging') {
        this.currentStep = 22;
      } else if (this.currentStep === 25 && this.additionalBorrowing === 'No') {
        this.currentStep = 27;
      } else if (this.currentStep === 27 && this.additionalRentalProps === 'No') {
        this.currentStep = 29;
      } else if (this.currentStep === 9 && this.typeBTL === 'HMO' && this.startOption === 'Remortgaging') {
        this.currentStep = 22;
      } else if (this.currentStep === 14 && this.typeBTL === 'LTD Company' && this.startOption === 'Remortgaging') {
        this.currentStep = 22;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 3 && this.typeBTL === 'Individual') {
        this.currentStep = 2;
      } else if (this.currentStep === 6 && this.typeBTL === 'HMO') {
        this.currentStep = 2;
      } else if (this.currentStep === 10 && this.typeBTL === 'LTD Company') {
        this.currentStep = 2;
      } else if (this.currentStep === 15 && this.typeBTL === 'Individual') {
        this.currentStep = 5;
      } else if (this.currentStep === 19 && this.typeBTL === 'Individual') {
        this.currentStep = 16;
      } else if (this.currentStep === 29 && this.firstTimeLandlord === 'Yes') {
        this.currentStep = 20;
      } else if (this.currentStep === 21 && this.firstTimeLandlord === 'No') {
        this.currentStep = 20;
      } else if (this.currentStep === 29 && this.firstTimeLandlord === 'No') {
        this.currentStep = 21;
      } else if (this.currentStep === 17 && this.typeBTL === 'Individual' && this.propertyInMind === 'No') {
        this.currentStep = 15;
      } else if (this.currentStep === 19 && this.typeBTL === 'Individual' && this.propertyInMind === 'No') {
        this.currentStep = 17;
      } else if (this.currentStep === 6 && this.typeBTL === 'HMO' ) {
        this.currentStep = 2;
      } else if (this.currentStep === 15 && this.typeBTL === 'HMO' && this.startOption === 'Purchasing') {
        this.currentStep = 9;
      } else if (this.currentStep === 17 && this.typeBTL === 'HMO'  && this.propertyInMind === 'No') {
        this.currentStep = 15;
      } else if (this.currentStep === 19 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'Yes') {
        this.currentStep = 16;
      } else if (this.currentStep === 17 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'No') {
        this.currentStep = 15;
      } else if (this.currentStep === 19 && this.typeBTL === 'LTD Company'  && this.propertyInMind === 'No') {
        this.currentStep = 17;
      } else if (this.currentStep === 18 && this.typeBTL === 'HMO') {
        this.currentStep = 16;
      } else if (this.currentStep === 22 && this.typeBTL === 'Individual' && this.startOption === 'Remortgaging') {
        this.currentStep = 5;
      } else if (this.currentStep === 27 && this.additionalBorrowing === 'No') {
        this.currentStep = 25;
      } else if (this.currentStep === 29 && this.additionalRentalProps === 'No') {
        this.currentStep = 27;
      } else if (this.currentStep === 22 && this.typeBTL === 'HMO' && this.startOption === 'Remortgaging') {
        this.currentStep = 9;
      } else if (this.currentStep === 22 && this.typeBTL === 'LTD Company' && this.startOption === 'Remortgaging') {
        this.currentStep = 14;
      } else if (this.currentStep === 31) {
        this.currentStep = 30;
      } else if (this.currentStep < this.totalSteps) {
        this.currentStep--;
      }
    },
  },
  computed: {
    isStepValid() {
      if (this.currentStep === 1) {
        return this.startOption === 'Purchasing' || this.startOption === 'Remortgaging';
      }
      if (this.currentStep === 2) {
        return this.typeBTL === 'Individual' || this.typeBTL === 'HMO' || this.typeBTL === 'LTD Company';
      }
      if (this.currentStep === 3) {
        return this.individualTaxRate === 'Yes' || this.individualTaxRate === 'No';
      }
      if (this.currentStep === 4) {
        return this.individualFixedMortgage === 'Yes' || this.individualFixedMortgage === 'No';
      }
      if (this.currentStep === 5) {
        return this.individualExpectedRent != null;
      }
      if (this.currentStep === 6) {
        return this.hmoPropertyHeldIn === 'Yes' || this.hmoPropertyHeldIn === 'No';
      }
      if (this.currentStep === 7) {
        return this.hmoLicence === 'Yes' || this.hmoLicence === 'No';
      }
      if (this.currentStep === 8) {
        return this.hmoFixedMortgage === 'Yes' || this.hmoFixedMortgage === 'No';
      }
      if (this.currentStep === 9) {
        return this.hmoExpectedRent != null;
      }
      if (this.currentStep === 10) {
        return this.ltdSpvInPlace === 'Yes' || this.ltdSpvInPlace === 'No';
      }
      if (this.currentStep === 11) {
        return this.ltdDirectorlQuantity != null;
      }
      if (this.currentStep === 12) {
        return this.ltdDirectorlIncome != null;
      }
      if (this.currentStep === 13) {
        return this.ltdFixedMortgage === 'Yes' || this.ltdFixedMortgage === 'No';
      }
      if (this.currentStep === 14) {
        return this.ltdExpectedRent != null;
      }
      if (this.currentStep === 15) {
        return this.propertyInMind === 'Yes' || this.propertyInMind === 'No';
      }
      if (this.currentStep === 16) {
        return this.purchaseValue != null;
      }
      if (this.currentStep === 17) {
        return this.approxPurchaseValue != null;
      }
      if (this.currentStep === 18) {
        return this.hmoLettableRooms != null;
      }
      if (this.currentStep === 19) {
        return this.requiredMortgageAmount != null;
      }
      if (this.currentStep === 20) {
        return this.firstTimeLandlord === 'Yes' || this.firstTimeLandlord === 'No';
      }
      if (this.currentStep === 21) {
        return this.propertiesQuantity != null;
      }
      if (this.currentStep === 22) {
        return this.approxPropValue != null;
      }
      if (this.currentStep === 23) {
        return this.outstandingMortgage != null;
      }
      if (this.currentStep === 24) {
        return this.currentLender != null;
      }
      if (this.currentStep === 25) {
        return this.additionalBorrowing === 'Yes' || this.additionalBorrowing === 'No';
      }
      if (this.currentStep === 26) {
        return this.borrowAmount != null;
      }
      if (this.currentStep === 27) {
        return this.additionalRentalProps === 'Yes' || this.additionalRentalProps === 'No';
      }
      if (this.currentStep === 28) {
        return this.additionalRentalPropsAmount != null;
      }
      if (this.currentStep === 29) {
        return this.calcReason1 != null;
      }
      if (this.currentStep === 30) {
        return this.calcReason2 != null;
      }
      return true;
    },
    /**
     * Check if previous logical section is completed
     * @return {Bool}
     */
    sectionCompleted() {
      return ( this.individualExpectedRent || this.hmoExpectedRent || this.ltdExpectedRent ) ? true : false
    },
    /**
     * Show button if previous section is completed
     * @return {Bool}
     */
    showListFields() {
      let listFields
      this.sectionCompleted
          ? ( this.firstTimeLandlord === 'Yes' || this.additionalRentalProps === 'No' ) || ( this.propertiesQuantity > 0 || this.additionalRentalPropsAmount > 0 ) ? listFields = true : listFields = false
          : listFields = false
      return listFields
    },
    showCalculateButton() {
      let calculateButton
      this.sectionCompleted
          ? ( this.firstTimeLandlord === 'Yes' || this.additionalRentalProps === 'No' ) || ( this.propertiesQuantity > 0 || this.additionalRentalPropsAmount > 0 ) ? calculateButton = true : calculateButton = false
          : calculateButton = false
      return calculateButton
    },
    indiv20Calc() {
      return (((this.individualExpectedRent * 12) / 1.25) / 0.05);
    },
    indiv40Calc() {
      return (((this.individualExpectedRent * 12) / 1.40) / 0.0525);
    },
    hmoCalc() {
      return (((this.hmoExpectedRent * 12) / 1.70) / 0.065);
    },
    ltdCalc() {
      return (((this.ltdExpectedRent * 12) / 1.25) / 0.05);
    },
    collateMessageBody() {
      const calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Are you purchasing or remortgaging a Buy-To-Let: ${this.startOption}
					Type of Buy-to-Let: ${this.typeBTL}
					
					Individual:
						Is your tax rate 40% or higher? ${this.formatEmptyMessageFields(this.individualTaxRate)}
						If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing? £${this.formatEmptyMessageFields(this.individualFixedMortgage)}
						How much rent do you get or expect to get? £${this.formatEmptyMessageFields(this.individualExpectedRent)}
					HMO:
						Will or is the property held in a limited company? ${this.formatEmptyMessageFields(this.hmoPropertyHeldIn)}
						Does the property have an HMO Licence? ${this.formatEmptyMessageFields(this.hmoLicence)}
						How many lettable rooms does the property have? ${this.formatEmptyMessageFields(this.hmoLettableRooms)}
						If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing? £${this.formatEmptyMessageFields(this.hmoFixedMortgage)}
						How much rent do you get or expect to get? £${this.formatEmptyMessageFields(this.hmoExpectedRent)}
					LTD Company:
						Do you have an SPV in place? ${this.formatEmptyMessageFields(this.ltdSpvInPlace)}
						How many Directors are in the company? ${this.formatEmptyMessageFields(this.ltdDirectorlQuantity)}
						How much personal income do you earn per year? £${this.formatEmptyMessageFields(this.ltdDirectorlIncome)}
						If necessary, would you be prepared to fix your mortgage for 5 years to potentially increase your borrowing? £${this.formatEmptyMessageFields(this.ltdFixedMortgage)}
						How much rent do you get or expect to get? £${this.formatEmptyMessageFields(this.ltdExpectedRent)}

					Do you have a property in mind? ${this.propertyInMind}
					
					What is the purchase price? £${this.formatEmptyMessageFields(this.purchaseValue)}
					Approximately, what value would you like to purchase at? £${this.formatEmptyMessageFields(this.approxPurchaseValue)}				
					What is your required mortgage amount? £${this.requiredMortgageAmount}
					Are you a first time landlord? ${this.firstTimeLandlord}				
					How many rental properties do you own? ${this.propertiesQuantity}
					
					What is the approximate value of your property? £${this.approxPropValue}
					What is your current outstanding mortgage amount? £${this.outstandingMortgage}
					Who is your current lender? ${this.currentLender}
					Are you remortgaging with additional borrowing? ${this.additionalBorrowing}			
					How much more would you like to borrow? £${this.borrowAmount}
					Do you have any more rental properties? ${this.additionalRentalProps}				
					How many? ${this.additionalRentalPropsAmount}
					
					You may be able to borrow: £${this.result}
          Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>